import React, { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import './Page.less';
import './ConsortiumItem.less';
import { Tab, Tabs } from '../components/Tabs';
import TabDescription from '../components/ConsortiumTabs/TabDescription';
import TabParticipants from '../components/ConsortiumTabs/TabParticipants';
import TabStrategyProjectsConnection from '../components/ConsortiumTabs/TabStrategyProjectsConnection';
import TabSubProjectsConnection from '../components/ConsortiumTabs/TabSubProjectsConnection';
import TabDocs from '../components/ConsortiumTabs/TabDocs';
import api from '../api';

export default function ConsortiumItem() {
  const { consortiumId } = useParams();
  const [error, setError] = useState(null);
  const [isLoaded, setIsLoaded] = useState(false);
  const [consortium, setConsortiums] = useState([]);
  const tabs = [
    { label: 'description', tabName: 'Описание', content: <TabDescription data={consortium} /> },
    { label: 'participants', tabName: 'Участники', content: <TabParticipants data={consortium} /> },
    { label: 'strategy-projects-connection', tabName: 'Связь со стратегическими проектами', content: <TabStrategyProjectsConnection data={consortium} /> },
    // {label: 'sub-projects-connection', tabName: 'Связь с подпроектами', content: <TabSubProjectsConnection data={consortium}/>},
    // {label: 'docs', tabName: 'Документы', content: <TabDocs data={consortium}/>},
  ];

  useEffect(async () => {
    try {
      const result = await api.get(`/info/consortiums/${consortiumId}`);
      setConsortiums(result);
      setIsLoaded(true);
    } catch (error) {
      setIsLoaded(true);
      setError(error);
    }
  }, []);

  if (error) {
    return (
      <div style={{ color: 'red', background: 'white' }}>
        Ошибка:
        {error.message}
      </div>
    );
  } if (!isLoaded) {
    return <section className="page"><div className="container"><div>Загрузка...</div></div></section>;
  }
  return (
    <div className="page consortium-item-page">
      <article>
        <h3 className="left-aligned-no-icon">{consortium.name}</h3>
        <Tabs>
          {tabs.map((tab, i) => (
            <Tab key={i} label={tab.label} tabName={tab.tabName}>
              {tab.content}
            </Tab>
          ))}
        </Tabs>
      </article>
    </div>
  );
}
